const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/MetaKatLocalizedText/MetaKatTranslation.tsx';
import React from 'react';
import { useIntl } from 'react-intl';
import textMap from './translations';
import { MetaKatTranslations, MetaKatTranslationSupportedLanguage } from 'App/defs/types';

type MetaKatLocalizedTextProps = {
    translations: MetaKatTranslations;
};

const defaultLanguage: MetaKatTranslationSupportedLanguage = 'DE';

export const MetaKatTranslation = (props: MetaKatLocalizedTextProps) => {
    const { locale, formatMessage } = useIntl();
    const supportedLanguage: MetaKatTranslationSupportedLanguage[] = Object.keys(
        props.translations
    ) as MetaKatTranslationSupportedLanguage[];
    const uppercaseLocale = locale.toUpperCase() as MetaKatTranslationSupportedLanguage;

    const metaKatTextTranslated = supportedLanguage.includes(uppercaseLocale)
        ? props.translations[uppercaseLocale]
        : props.translations[defaultLanguage];

    return <>{metaKatTextTranslated || formatMessage(textMap.translationMissing)}</>;
};
